import React from "react";
import { connect } from "react-redux";
import { removeIsPRODADeviceExpiryWarning } from "../../reduxStore/actions/auth";
import { getDateDiffFromTodayInDays, isAfterToday } from "../../utils/dateTimeHelper";

const PRODADeviceExpiryReminder = props => {
  const { user } = props;
  const date = new Date();
  const currentTimestamp = date.getTime();
  let deviceExpiry;
  let keyExpiry;
  let keyExpiresIn = 0;

  if (user.PRODAInfo && user.PRODAInfo.deviceExpiry) {
    deviceExpiry = user.PRODAInfo.deviceExpiry.split(" ")[0];
    deviceExpiry =
      deviceExpiry.split("-")[2] +
      "/" +
      deviceExpiry.split("-")[1] +
      "/" +
      deviceExpiry.split("-")[0];
  }

  if (user.PRODAInfo && user.PRODAInfo.keyExpiry) {
    keyExpiry = isAfterToday(user.PRODAInfo.keyExpiry, "YYYY-MM-DD HH:mm:ss");
    keyExpiresIn = getDateDiffFromTodayInDays(user.PRODAInfo.keyExpiry, "YYYY-MM-DD HH:mm:ss");
  }



  return (
    <div
      style={{ width: "100%", zIndex: 200, position: "absolute", top: "75px" }}
    >
      {user &&
        user.isPRODADeviceExpiryWarning &&
        user.PRODAInfo &&
        user.PRODAInfo.deviceExpiryTimestamp <
          currentTimestamp + 1000 * 60 * 60 * 24 * 30 && (
          <p className="bg-danger text-white text-center w-100">
            <span className="col-10 offset-1">
              WARNING! Expiring {deviceExpiry} - please update the PRODA Device
              Activation Code
            </span>
            <i
              className="fas fa-times col-1 mt-1"
              onClick={() => props.removeIsPRODADeviceExpiryWarning()}
            />
          </p>
        )}
      {user && (!user.PRODAInfo || Object.keys(user.PRODAInfo).length === 0) && (
        <p className="bg-danger text-white text-center w-100">
          <span className="col-10 offset-1">
            WARNING! PRODA Credentials cannot be found. PRODA and Medicare
            Online services are not available. Please activate the PRODA Device
            to fix this issue.
          </span>
        </p>
      )}
      {user &&
        user.PRODAInfo &&
        user.PRODAInfo.deviceExpiryTimestamp < currentTimestamp && (
          <p className="bg-danger text-white text-center w-100">
            <span className="col-10 offset-1">
              WARNING! PRODA Device Activation Code has expired. PRODA and
              Medicare Online services are not available. Please submit a new
              PRODA Device Activation Code now.
            </span>
          </p>
        )}
      {user &&
        user.PRODAInfo &&
        user.PRODAInfo.keyExpiry && keyExpiry && (
          <p className="bg-danger text-white text-center w-100">
            <span className="col-10 offset-1">
              WARNING! PRODA Device Key Expired expired. PRODA and
              Medicare Online services are not available. Please create a new Device and Pass the information to devs.
            </span>
          </p>
        )}
      {user &&
        user.PRODAInfo &&
        user.PRODAInfo.keyExpiry && keyExpiry && (keyExpiresIn > 0 && keyExpiresIn < 5) && (
          <p className="bg-danger text-white text-center w-100">
            <span className="col-10 offset-1">
              WARNING! PRODA Device Key will expire in {keyExpiresIn} days. Please inform devs.
            </span>
          </p>
        )}
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user
});

const mapDispatchToProps = dispatch => ({
  removeIsPRODADeviceExpiryWarning: () =>
    dispatch(removeIsPRODADeviceExpiryWarning())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PRODADeviceExpiryReminder);
